module.exports = __webpack_public_path__ + "img/jdm-screen-prot.30e9cc86.png";